import { render } from "./App.vue?vue&type=template&id=7afb6088"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=7afb6088&lang=css"

import exportComponent from "D:\\Workspace\\weedheads\\10-gemfarm\\custom-ui\\gem-farm\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__